import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Titulo from "../../../atoms/titles/Titulo"


import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { getPDFIRPF } from "../../../services/IRPFService";


const VerIrpfPDF = (object) => {
  const navigate = useNavigate();

  // const [params] = useParams();
  const datosIrpfSelect = JSON.parse(localStorage.getItem("datosIrpfSelect"))
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState();
  const [file,setFile] = useState();
  // const [mensaje, setMensaje] = useState();


  useEffect(() => {
    // setLoading(false)
    getPDFIRPF(datosIrpfSelect?.anyo).then((data) => {
     
      setFile(data)
      setLoading(true)
      if (data.type === 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          setSolicitud(base64data);
          setLoading(false);
        };
      } else {
        // data.text().then((text) => {
        //   setMensaje(text); // Guarda el contenido textual
        //   setLoading(true); // Actualiza el estado
        // }).catch((error) => {
        //   setLoading(false); // Manejo de error
        // });
      }
    });
  }, [datosIrpfSelect?.anyo])

  return (<>
    <Header />
    <div className="container-fluid">
      {!loading ? (<>
        <div className="datosPersonalesCarrera d-flex flex-column m-2">
          <div>
            <div className="d-flex justify-content-between">
              <Titulo
                clases={"subSubTituloSolicitud p-2 fw-bold"}
                tipo={"tituloCard noBg"}
                titulo={`IRPF - ${datosIrpfSelect?.anyo}`}
              ></Titulo>
            </div>
            <div className="separador"></div>
          </div>

          <div className="formulario">
            <>
              <div className="m-2"></div>
              <div className="m-3 card scroll-list container-list-border">
                <div className="gridPresentar">
                  <div className="iframePresentar pt-3">
                    {solicitud && file.size !== 0 ? (
                      <object
                        data={solicitud}
                        type="application/pdf"
                        height="500"
                        width="100%"
                        aria-label="PDF del borrador"
                        className="rounded"
                        name="sol"
                      />
                    ) : (
                      <p style={{ height: "500px", width: "100%" }}>
                        Actualmente no están cargados en el sistema
                        los datos del Certificado que desea consultar.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
            <div className="gridBotones mb-2">
              <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion"
                type="button"
                onClick={() => {
                  localStorage.removeItem("datosIrpfSelect")
                  navigate("/home")

                }}
              >
                <i className="fa-solid fa-rotate-left"></i> Volver
              </button>
            </div>
          </div>
        </div>
      </>) : (<div className=""><SpinnerCircle /></div>)}
    </div>
    <Footer />
  </>)
}

export default VerIrpfPDF;